import Attachment from './formats/attachment'
import AttachmentModule from './module'
import Quill from 'quill'

const BlockEmbed = Quill.import('blots/block/embed');

class UploadedVideo extends BlockEmbed {
  static create(url: string) {
    const node = super.create() as HTMLVideoElement;
    node.setAttribute('src', url);
    node.setAttribute('controls', '');
    node.setAttribute('preload', 'metadata');
    node.style.maxWidth = '100%';
    return node;
  }

  static value(node: HTMLVideoElement) {
    return node.getAttribute('src') || '';
  }
}

UploadedVideo.blotName = 'uploadedVideo';
UploadedVideo.tagName = 'video';

Quill.register({
  'formats/attachment': Attachment,
  'formats/uploadedVideo': UploadedVideo
});

export default AttachmentModule